import React from 'react';
import { BrainIcon, BookOpenIcon, UsersIcon, BellIcon } from 'lucide-react';
interface Notification {
  id: number;
  type: 'alga' | 'regular';
  title: string;
  description: string;
  time: string;
  read: boolean;
}
const notifications: Notification[] = [{
  id: 1,
  type: 'alga',
  title: 'Sintesi settimanale',
  description: 'Il tuo report settimanale è pronto da consultare',
  time: '2 ore fa',
  read: false
}, {
  id: 2,
  type: 'regular',
  title: 'Nuovo commento',
  description: 'Mario Rossi ha commentato il tuo post',
  time: '4 ore fa',
  read: false
}, {
  id: 3,
  type: 'alga',
  title: 'Suggerimento ALGA',
  description: 'Ho trovato dei contenuti interessanti per te',
  time: '1 giorno fa',
  read: true
}];
interface NotificationsMenuProps {
  isOpen: boolean;
  onClose: () => void;
}
const NotificationsMenu: React.FC<NotificationsMenuProps> = ({
  isOpen,
  onClose
}) => {
  if (!isOpen) return null;
  const NotificationItem = ({
    notification
  }: {
    notification: Notification;
  }) => <div className={`p-4 border-b border-gray-100 hover:bg-gray-50 cursor-pointer ${!notification.read ? 'bg-gray-50' : ''}`} data-id="element-1299">
      <div className="flex items-start gap-3" data-id="element-1300">
        {notification.type === 'alga' ? <div className="flex items-center gap-2" data-id="element-1301">
            <div className="w-8 h-8 rounded-full overflow-hidden border-2 border-pink-500" data-id="element-1302">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI Assistant" className="w-full h-full object-cover" data-id="element-1303" />
            </div>
          </div> : <div className="mt-1" data-id="element-1304">
            <BellIcon size={16} className="text-blue-500" data-id="element-1305" />
          </div>}
        <div className="flex-1" data-id="element-1306">
          <p className="text-sm font-medium text-gray-900" data-id="element-1307">
            {notification.title}
          </p>
          <p className="text-sm text-gray-500" data-id="element-1308">{notification.description}</p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-1309">{notification.time}</p>
        </div>
        {!notification.read && <div className="w-2 h-2 rounded-full bg-custom-green" data-id="element-1310"></div>}
      </div>
    </div>;
  return <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-gray-200 z-50" data-id="element-1311">
      <div className="p-4 border-b border-gray-200" data-id="element-1312">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-1313">Notifiche</h3>
      </div>
      <div className="max-h-[400px] overflow-y-auto" data-id="element-1314">
        {notifications.map(notification => <NotificationItem key={notification.id} notification={notification} data-id="element-1315" />)}
      </div>
      <div className="p-3 text-center border-t border-gray-200" data-id="element-1316">
        <button className="text-sm text-custom-green hover:text-custom-green/80" data-id="element-1317">
          Vedi tutte le notifiche
        </button>
      </div>
    </div>;
};
export default NotificationsMenu;